// src/redux/actions/likesActions.js

export const setLikesSent = (likes) => ({
  type: "SET_LIKES_SENT",
  payload: likes,
});

export const setLikesReceived = (likes) => ({
  type: "SET_LIKES_RECEIVED",
  payload: likes,
});

export const addLikeSent = (like) => ({
  type: "ADD_LIKE_SENT",
  payload: like,
});

export const addLikeReceived = (like) => ({
  type: "ADD_LIKE_RECEIVED",
  payload: like,
});
export const setLikesSentDonneurOrdre = (likes) => ({
  type: "SET_LIKES_SENT_DONNEUR_ORDRE",
  payload: likes,
});

export const setLikesReceivedDonneurOrdre = (likes) => ({
  type: "SET_LIKES_RECEIVED_DONNEUR_ORDRE",
  payload: likes,
});

export const addLikeSentDonneurOrdre = (like) => ({
  type: "ADD_LIKE_SENT_DONNEUR_ORDRE",
  payload: like,
});

export const addLikeReceivedDonneurOrdre = (like) => ({
  type: "ADD_LIKE_RECEIVED_DONNEUR_ORDRE",
  payload: like,
});

export const sendLike = (idProjet, idPrestataire, token) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const formData = new FormData();
      formData.append("idProjet", idProjet);
      if(idPrestataire){
        formData.append("idPrestataire", idPrestataire);
      }
      const response = await fetch(apiUrl+"/api/likes", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors de l’envoi du like");
      }

      if (data.status === "like") {
        dispatch({ type: "ADD_LIKE_SENT", payload: data.like || { idProjet } });
      } else if (data.status === "match") {
        dispatch({ type: "ADD_MATCH", payload: data.matchId });
      }

      return data;
    } catch (error) {
      console.error("Erreur envoi like:", error);
      throw error;
    }
  };
};

// ---------- ACTION ASYNCHRONE : RÉCUPÉRER LES LIKES ENVOYÉS ----------
export const fetchLikesSent = (token) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/likes/sent`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement des likes envoyés");
      }

      dispatch(setLikesSent(data.likesSend || []));
      return data.likesSent;
    } catch (error) {
      console.error("Erreur fetchLikesSent:", error);
      throw error;
    }
  };
};

// ---------- ACTION ASYNCHRONE : RÉCUPÉRER LES LIKES REÇUS ----------
export const fetchLikesReceived = (token) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/likes/received`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement des likes reçus");
      }

      dispatch(setLikesReceived(data.likesReceived || []));
      return data.likesReceived;
    } catch (error) {
      console.error("Erreur fetchLikesReceived:", error);
      throw error;
    }
  };
}



export const sendLikeDonneurOrdre = (idAppelOffre, idPrestataire, token) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const formData = new FormData();
      formData.append("idAppelOffre", idAppelOffre);
      if(idPrestataire){
        formData.append("idPrestataire", idPrestataire);
      }
      const response = await fetch(apiUrl+"/api/likesDonneurOrdre", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors de l’envoi du like");
      }

      if (data.status === "like") {
        dispatch({ type: "ADD_LIKE_SENT_DONNEUR_ORDRE", payload: data.like || { idAppelOffre } });
      } else if (data.status === "match") {
        dispatch({ type: "ADD_MATCH_DONNEUR_ORDRE", payload: data.matchId });
      }

      return data;
    } catch (error) {
      console.error("Erreur envoi like:", error);
      throw error;
    }
  };
};

// ---------- ACTION ASYNCHRONE : RÉCUPÉRER LES LIKES ENVOYÉS ----------
export const fetchLikesSentDonneurOrdre = (token) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/likesDonneurOrdre/sent`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement des likes envoyés");
      }

      dispatch(setLikesSentDonneurOrdre(data.likesSend || []));
      return data.likesSent;
    } catch (error) {
      console.error("Erreur fetchLikesSent:", error);
      throw error;
    }
  };
};

// ---------- ACTION ASYNCHRONE : RÉCUPÉRER LES LIKES REÇUS ----------
export const fetchLikesReceivedDonneurOrdre = (token) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/likesDonneurOrdre/received`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement des likes reçus");
      }

      dispatch(setLikesReceivedDonneurOrdre(data.likesReceived || []));
      return data.likesReceived;
    } catch (error) {
      console.error("Erreur fetchLikesReceived:", error);
      throw error;
    }
  };
}
